<template>
  <div class="right_body"> 
      <SaleOrgFormWindow ref="saleOrgFWin" :visible="window.visible" @onClose="onCloseNeWindow" @onSuccess="onModifySuccess"></SaleOrgFormWindow>  
	  <aside-layout>
        <template v-slot:aside>
           <sale-organ-tree ref="organTree" @onSelectTreeNode="onLoadSaleOrg"></sale-organ-tree>
        </template>
        <template v-slot:main>
          <Panel>
              <template v-slot:panel-top>
                  <Toolbar :items=toolbarItems 
                           @onNewSaleOrg="onNewSaleOrg"  
                           @onEditSaleOrg="onEditSaleOrg"
                           @onDelSaleOrg="onDelSaleOrg"
                           @onRefresh="onRefresh"></Toolbar>
              </template>
              <template v-slot:panel-main>                   
                   <el-form ref="formPanelContent" :rules="formRules" :model="formData" size="mini">
                       <div class="form-panel flex">
                            <div v-for="(item,index) in formItems"  class="form-panel-column-30" :key="index">
                                <div class="flex-nowrap">
                                    <span class="txt">{{item.title}}</span>  
                                    <el-input :class="{'activeErr':item.isActive}" v-if="item.type=='text'" type="text" :readonly=item.readonly :placeholder=item.hintTxt v-model="$data.formData[item.field]" size="small" :maxlength=item.maxlength show-word-limit></el-input>
                                    <el-switch v-if="item.type=='switch'" v-model="$data.formData[item.field]" :readonly=item.readonly></el-switch>
                                    <el-date-picker v-if="item.type=='date'"  v-model="$data.formData[item.field]" type="date" :readonly=item.readonly :placeholder=item.hintTxt size="small"></el-date-picker>
                                    <!-- <CompanyEyeInput  v-if="item.type=='company'" v-model="$data.formData[item.field]"  size="small" @onEyeChange="onEyeChange"></CompanyEyeInput>  -->
                                </div>
                                <div v-if="item.validateState === 'error' && item && item.serveMsg" style="margin-left:27%;font-size:12px;color:#f56c6c;margin-top:4px">{{item.serveMsg}}</div>                                                                                                                    
                            </div>
                        </div>
                   </el-form>
              </template>
              
          </Panel>
        </template>
      </aside-layout>      
  </div>
    
</template>
<script>
import AsideLayout from 'components/container/AsideLayout.vue';
import Panel from 'components/container/BasePanel.vue'
import Toolbar from 'components/bar/Toolbar.vue'
import ToolItem from 'components/btn/listBtn.vue'
import SaleOrganTree from './ui/SaleOrganTree.vue'
import FormItemBar from 'components/form/form-item.vue' 
import EyeglassInput from 'components/input/EyeglassInput.vue'
import CompanyQWindow from 'busicomponent/window/CompanyQWindow.vue'
import CompanyEyeInput from 'busicomponent/input/company/CompanyEyeInput.vue'
import SaleOrgFormWindow from './ui/SaleOrgNeFWindow.vue'

import SaleOrgService from './service/SaleOrgService.js';
import {listToTree} from 'utils/algorithm/DataStructure'

const FormPanelData={
    toolBarItems:[{
               class:"toolbar-item add_btn",
               name:"新增", 
               click:"onNewSaleOrg",
               iconfont:"&#xe7e4;" 
          },{ 
               class:"toolbar-item edit_btn",
               name:"编辑",
               click:"onEditSaleOrg",
               iconfont:"&#xe678;" 
          },{
               class:"toolbar-item del_btn",
               name:"删除",
               click:"onDelSaleOrg",
               iconfont:"&#xe618;" 
          }],
    formItems:[
        // {title:"销售组织码:",hintTxt:"请输入销售组织",field:"saleOrgCode",maxlength:35,class:"form-panel-column-30",type:"text",serveMsg:"",validateState:'error'},
        {title:"销售组织码:",hintTxt:"请输入销售组织",field:"saleOrgCode",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"销售组织名:",hintTxt:"请输入销售组织名",field:"saleOrgDesc",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"公司名:",hintTxt:"请输入公司编码",field:"companyName",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"库存地:",hintTxt:"请输入库存地",field:"inventoryDesc",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"工厂:",field:"factoryDesc",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"线上订单自动转:",field:"onlineOrderAutoSync",maxlength:35,class:"form-panel-column-30",type:"switch",readonly:true},        
        {title:"店铺ID:",hintTxt:"请输入店铺ID",field:"shopCode",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"店铺名:",hintTxt:"请输入店铺名",field:"shopDesc",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},
        {title:"所属平台:",hintTxt:"请输入所属平台",field:"belongPlatform",maxlength:35,class:"form-panel-column-30",type:"text",readonly:true},        
        {title:"创建时间:",hintTxt:"请输入创建时间",field:"createDate",maxlength:35,class:"form-panel-column-30",type:"date",readonly:true},
        {title:"修改时间:",hintTxt:"请输入修改时间",field:"lastModifyDate",maxlength:35,class:"form-panel-column-30",type:"date",readonly:true},
   ],
   formRules: {
        saleOrgCode:[{required: true,message: "请输入物料描述",trigger: "blur"}],
        saleOrgName:[{required: true,message: '',trigger: 'change'}]
   },
   //formData:{}
}

/**
 * 操作状态
 */
const BusinessStatusType={
    new:'new',
    edit:"edit",
    scan:"scan"
}

export default {
    components:{
        AsideLayout,SaleOrganTree,Toolbar,Panel,
        ToolItem,EyeglassInput,CompanyQWindow,CompanyEyeInput,
        SaleOrgFormWindow
    },
    props:{
       formItems:{
           Type:Array,
           default(){
               return FormPanelData.formItems;
           }
       }
    },
    data(){
       return{
          statusType:BusinessStatusType.scan,
          formRules:FormPanelData.formRules,
          formData:{
              saleOrgCode:'',
              saleOrgName:'',
              companyId:'',
              companyCode:'',
              companyName:'',
          },
          toolbarItems:FormPanelData.toolBarItems,
          window:{
              visible:false,
          }
       }
    },
    methods:{
        ...SaleOrgService,
        /**
         * 新增
         */
        onNewSaleOrg(){
            let vm=this;   
            debugger;    
            vm.statusType=BusinessStatusType.new;  
            this.$refs.saleOrgFWin.type=vm.statusType;
            vm.window.visible=true;
        },
        /**
         * 修改
         */
        onEditSaleOrg(){
            let vm=this,saleOrgForm=vm.formData;
            
            //业务功能类型
            vm.statusType=BusinessStatusType.edit;  
            vm.$refs.saleOrgFWin.type=vm.statusType;
            
            vm.window.visible=true;
            //加载编辑数据
            vm.$refs.saleOrgFWin.loadEditData(saleOrgForm);            
        },
        /**
         * 删除
         */
        onDelSaleOrg(){
            let vm=this,saleOrgForm=vm.formData;
            vm.statusType=BusinessStatusType.scan;  

            if(saleOrgForm["saleOrgId"]==null ||saleOrgForm["saleOrgId"]==undefined){
                vm.$message.error("执行删除无效，销售组织ID标识不存在");
                return;
            }
            vm.$confirm("确定删除么, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消", 
                type: "warning"
            }).then(() =>{
               vm.removeSaleOrgan(saleOrgForm,function(resResult){ 
                    if(resResult){
                        vm.formData={};
                        vm.$refs.organTree.refreshSaleOrgTree();
                    }
                });
            }).catch(() =>{
                vm.$message.success("已取消删除");
            });            
        },
        /**
         * 打印
         */
        onPrint(){
            let vm=this,saleOrgForm=vm.formData;
            vm.submitSaleOrgan(saleOrgForm,function(resResult){ 
                console.log(resResult);   
                if(resResult){
                  vm.validate(resResult.errorFields);
                }
            });
        },
        /**
         * 刷新
         */
        onRefresh(){
          let vm=this;
          //非预览状态，不能刷新
          if(vm.statusType!=BusinessStatusType.scan){
             vm.$message.error('非浏览状态不能刷新数据');
             return;
          }
          vm.querySaleOrgan({saleOrgId:vm.formData.saleOrgId},function(response){
               if(response.data){
                 vm.formData=response.data;
               }else{
                 vm.formData={};  
               }                
           });
        },
        /**
         * 关闭新增修改窗体
         */
        onCloseNeWindow(){
           this.window.visible=false;
        },
        /**
         * 销售组织新增或修改成功
         */
        onModifySuccess(formData){
            let vm=this;
            vm.window.visible=false;
            vm.formData=formData;
           
            vm.$refs.organTree.refreshSaleOrgTree();

            vm.onLoadSaleOrg(formData);
        },
        /**
         * 加载销售组织
         */
        onLoadSaleOrg(row){       
           let vm=this;
           if(row.type!='O'){
               return;
           }
           this.querySaleOrgan({saleOrgId:row.saleOrgId},function(response){
               if(response.data){
                 vm.formData=response.data;
               }else{
                 vm.formData=[];  
               }                
           });
        },
        onEyeChange(companyRow){
           if(companyRow){
               this.formData.companyId=companyRow.companyId;
               this.formData.companyCode=companyRow.companyCode;
               this.formData.companyName=companyRow.companyName;
           }
        },
        validate(errorFields){
            let vm=this;
            if(!errorFields){
                return;
            }
            let error={};
            errorFields.forEach(item=>{
                error[item.errorField]=item.errorDesc;
            });
            vm.formItems.forEach(item=>{
                if(error[item.field]){
                    item.validateState='error';
                    item.serveMsg=error[item.field];
                    item.isActive=true;
                }else{
                   item.validateState='';
                   item.serveMsg='';
                   item.isActive=false; 
                }
            });
        }
    }
    
}
</script>

<style>
    .activeErr .el-input__inner{
        border-color: #f56c6c;
    }
</style>
